import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./dstyle.css";
import SideBar from "./SideBar";
import Navbar from "./Navbar";
import axios from "axios";
import { toast } from "react-toastify";
import { Modal } from "antd";
import { API_BASE_URL } from "../../config/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faPlus,
  faStar,
  faFire,
  faBookOpen,
  faClipboardQuestion,
  faChalkboardUser,
  faSpinner
} from "@fortawesome/free-solid-svg-icons";

function Courses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isDeleted, setDeleted] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [cid, setCid] = useState(-1);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/courses`)
      .then((response) => response.json())
      .then((data) => {
        setCourses(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching courses:", error);
        setLoading(false);
      });
  }, [isDeleted, refreshKey]);

  function deleteCourse(courseId) {
    axios
      .delete(`${API_BASE_URL}/api/courses/${courseId}`)
      .then(() => {
        toast.success("Course deleted successfully.");
        setDeleted(true);
      })
      .catch((error) => {
        console.error("Delete error:", error);
        toast.error("Could not delete course.");
      });
    setCid(-1);
  }

  function toggleFeatured(courseId) {
    const course = courses.find((c) => Number(c.course_id || c.id) === Number(courseId));
    const isCurrentlyTrending = course && (course.featured === 1 || Number(course.featured) === 1);
    const trendingCount = courses.filter((c) => c.featured === 1 || Number(c.featured) === 1).length;

    if (!isCurrentlyTrending && trendingCount >= 6) {
      toast.warning("Maximum 6 trending courses allowed. Please unmark another course first.", {
        position: "top-right"
      });
      return;
    }

    axios
      .put(`${API_BASE_URL}/api/courses/${courseId}/featured`)
      .then((response) => {
        setRefreshKey((prev) => prev + 1);
        toast.success(
          response.data.featured
            ? "Course marked as Trending (up to 6 allowed)!"
            : "Course removed from Trending."
        );
      })
      .catch((error) => {
        console.error("Featured toggle error:", error);
        const msg = error.response?.data?.error || "Could not toggle trending status.";
        toast.error(msg);
      });
  }

  const trendingCount = courses.filter((c) => c.featured === 1 || Number(c.featured) === 1).length;

  return (
    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <SideBar current={"courses"} />
      <section id="content">
        <Navbar />
        <main style={{ padding: "28px" }}>
          {/* Header */}
          <div
            style={{
              marginBottom: "28px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "16px"
            }}
          >
            <div>
              <h1
                style={{
                  color: "#0f172a",
                  fontFamily: "'Outfit', sans-serif",
                  fontSize: "1.8rem",
                  fontWeight: 800,
                  margin: 0
                }}
              >
                Course Catalog Management
              </h1>
              <p style={{ color: "#64748b", margin: "4px 0 0", fontSize: "0.9rem" }}>
                Add new courses, manage assessments, or select Trending Courses (
                <strong style={{ color: trendingCount >= 6 ? "#ea580c" : "#2563eb" }}>
                  {trendingCount}/6 selected
                </strong>
                ) for homepage and navbar showcases
              </p>
            </div>

            <button
              onClick={() => navigate("/addcourse")}
              style={{
                background: "linear-gradient(135deg, #4f46e5 0%, #3730a3 100%)",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "10px 20px",
                fontWeight: 700,
                fontSize: "0.9rem",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                boxShadow: "0 4px 14px rgba(79, 70, 229, 0.3)"
              }}
            >
              <FontAwesomeIcon icon={faPlus} /> Add New Course
            </button>
          </div>

          {/* Courses List Container */}
          <div
            style={{
              background: "#fff",
              borderRadius: "20px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 4px 6px -1px rgba(0,0,0,0.03)",
              overflow: "hidden"
            }}
          >
            <div
              style={{
                padding: "18px 24px",
                borderBottom: "1px solid #f1f5f9",
                background: "#fafbff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontWeight: 800,
                  color: "#0f172a",
                  fontSize: "1.05rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}
              >
                <FontAwesomeIcon icon={faBookOpen} style={{ color: "#4f46e5" }} />
                All Active Courses
              </h3>
              <span
                style={{
                  background: "#e0e7ff",
                  color: "#4f46e5",
                  borderRadius: "20px",
                  padding: "4px 14px",
                  fontSize: "0.82rem",
                  fontWeight: 700
                }}
              >
                {courses.length} Courses
              </span>
            </div>

            <div style={{ padding: "20px 24px" }}>
              {loading ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: "#64748b" }}>
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                    style={{ fontSize: "2rem", color: "#4f46e5", marginBottom: "10px" }}
                  />
                  <p>Loading course list...</p>
                </div>
              ) : courses.length === 0 ? (
                <p style={{ color: "#94a3b8", textAlign: "center", margin: "20px 0" }}>
                  No courses found. Click "Add New Course" above to create one.
                </p>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  {courses.map((course) => {
                    const cId = course.course_id || course.id;
                    const name = course.course_name || course.courseName || `Course #${cId}`;
                    const instructor = course.instructor || course.tutor || "Faculty";

                    return (
                      <div
                        key={cId}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "16px 20px",
                          background: "#ffffff",
                          borderRadius: "14px",
                          border: "1px solid #e2e8f0",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                          flexWrap: "wrap",
                          gap: "14px"
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "14px", flex: 1, minWidth: "240px" }}>
                          <img
                            src={
                              course.p_link ||
                              course.photo ||
                              "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=100&auto=format&fit=crop&q=60"
                            }
                            alt={name}
                            style={{
                              width: "56px",
                              height: "56px",
                              borderRadius: "10px",
                              objectFit: "cover",
                              flexShrink: 0
                            }}
                            onError={(e) => {
                              e.target.src =
                                "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=100&auto=format&fit=crop&q=60";
                            }}
                          />
                          <div>
                            <h4
                              style={{
                                margin: 0,
                                fontSize: "1rem",
                                fontWeight: 700,
                                color: "#0f172a"
                              }}
                            >
                              {name}
                            </h4>
                            <p
                              style={{
                                margin: "4px 0 0",
                                fontSize: "0.82rem",
                                color: "#64748b"
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faChalkboardUser}
                                style={{ marginRight: "6px", color: "#818cf8" }}
                              />
                              {instructor} • ${course.price || 0}
                              {course.category_name && (
                                <span style={{
                                  marginLeft: "8px",
                                  background: "#e0e7ff",
                                  color: "#4f46e5",
                                  padding: "2px 8px",
                                  borderRadius: "8px",
                                  fontSize: "0.72rem",
                                  fontWeight: 700
                                }}>
                                  {course.category_name}
                                </span>
                              )}
                            </p>
                          </div>
                        </div>

                        {/* Action Buttons */}
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                          {/* Toggle Featured / Trending */}
                          <button
                            onClick={() => toggleFeatured(cId)}
                            style={{
                              backgroundColor: course.featured ? "#ea580c" : "#f1f5f9",
                              color: course.featured ? "#fff" : "#475569",
                              border: course.featured ? "none" : "1px solid #cbd5e1",
                              borderRadius: "8px",
                              padding: "8px 14px",
                              cursor: "pointer",
                              fontSize: "0.85rem",
                              fontWeight: 700,
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              transition: "all 0.2s"
                            }}
                            title={course.featured ? "Remove from Trending (featured)" : "Select as Trending Course (max 6)"}
                          >
                            <FontAwesomeIcon icon={course.featured ? faFire : faStar} style={{ color: course.featured ? "#fff" : "#ea580c" }} />
                            {course.featured ? "Trending ★" : "Make Trending"}
                          </button>

                          {/* Manage Quiz / Questions */}
                          <button
                            onClick={() => navigate(`/addquestions/${cId}`)}
                            style={{
                              backgroundColor: "#06b6d4",
                              color: "#fff",
                              border: "none",
                              borderRadius: "8px",
                              padding: "8px 14px",
                              cursor: "pointer",
                              fontSize: "0.85rem",
                              fontWeight: 700,
                              display: "flex",
                              alignItems: "center",
                              gap: "6px"
                            }}
                            title="Import/Manage Markdown Quizzes"
                          >
                            <FontAwesomeIcon icon={faClipboardQuestion} /> Manage Quiz
                          </button>

                          {/* Edit Course */}
                          <button
                            onClick={() => navigate(`/editCourse/${cId}`)}
                            style={{
                              backgroundColor: "#e0e7ff",
                              color: "#4f46e5",
                              border: "none",
                              borderRadius: "8px",
                              padding: "8px 12px",
                              cursor: "pointer",
                              fontSize: "0.85rem",
                              fontWeight: 600
                            }}
                            title="Edit Course"
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>

                          {/* Delete Course */}
                          <button
                            onClick={() => {
                              setOpenModal(true);
                              setCid(cId);
                            }}
                            style={{
                              backgroundColor: "#fee2e2",
                              color: "#ef4444",
                              border: "none",
                              borderRadius: "8px",
                              padding: "8px 12px",
                              cursor: "pointer",
                              fontSize: "0.85rem",
                              fontWeight: 600
                            }}
                            title="Delete Course"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </main>
      </section>

      {/* Delete Modal */}
      <Modal
        title="Confirm Course Deletion"
        open={openModal}
        onOk={() => {
          setOpenModal(false);
          deleteCourse(cid);
        }}
        onCancel={() => setOpenModal(false)}
        okText="Yes, Delete Course"
        okButtonProps={{ danger: true }}
      >
        <p style={{ color: "#334155", fontSize: "0.95rem" }}>
          Are you sure you want to delete this course and all associated quiz questions?
        </p>
      </Modal>
    </div>
  );
}

export default Courses;
